import { Outlet } from 'react-router-dom'
import { useNotificationGoldenMay2026 } from 'src/pages/goldenMay2026/hook'

export const NotificationLayoutGoldenMay2026 = () => {
  const { contextHolder } = useNotificationGoldenMay2026()
  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  )
}
